
  <div *ngIf="isLoading" class="loading-page-overlay" >
    <kmd-loading-wheel></kmd-loading-wheel>
  </div>